import { render } from "./fire.vue?vue&type=template&id=2288ecee"
import script from "./fire.vue?vue&type=script&lang=js"
export * from "./fire.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__